import { render, staticRenderFns } from "./braze-wrapper.vue?vue&type=template&id=4516335c&scoped=true&"
import script from "./braze-wrapper.vue?vue&type=script&lang=js&"
export * from "./braze-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./braze-wrapper.vue?vue&type=style&index=0&id=4516335c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4516335c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrazeBellIcon: require('/var/web/bet777.es/components/braze-bell-icon.vue').default,BrazeNotificationCard: require('/var/web/bet777.es/components/braze-notification-card.vue').default})
